export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-inner">
        <div className="footer-logo">
          <span style={{fontSize:'1.5rem'}}>🏥</span>
          <span className="brand-name">MedSafety Connect</span>
        </div>
        <p className="footer-tagline">Adverse Drug Reaction Self-Reporting Portal</p>
        <div className="footer-credits">
          <span>Developed by <strong>Vasu Tilva</strong></span>
          <span className="footer-credits-divider">•</span>
          <span>Advised by <strong>Dr. Devangee Jivani</strong></span>
          <span className="footer-credits-divider">•</span>
          <span>Supervised by <strong>Dr. Barna Ganguly</strong></span>
        </div>
        <p className="footer-disclaimer">This platform is solely for academic and research purposes.</p>
        <p className="footer-copy">© {new Date().getFullYear()} MedSafety Connect. All data is confidential and for medical safety purposes only.</p>
      </div>
    </footer>
  );
}
